<template>
  <div class="flow-wrapper">
    <div class="bg-flow">
      <div class="bg-flow-wave"></div>
    </div>
    <div class="relative">
      <div class="flow-title">
        <v-icon>mdi-rhombus</v-icon>
        <span>決済手続きのご案内</span>
        <v-icon>mdi-rhombus</v-icon>
      </div>

      <div class="flow-card-wrapper">
        <div class="flow-card">
          <div class="card-tip">STEP1</div>
          <div class="card-title">fondiへのアカウント登録</div>
          <div class="card-underline"></div>
          <div class="card-body text-pre-wrap">
            <span
              >90 Englishとfondiの提携プランでは、通常の50%+オフでfondiをご利用いただけます。</span
            ><br /><span>まずは、fondiに無料でご登録いただき、無料プランをお試しください。</span>
          </div>
        </div>
        <div class="arrow-wrapper">
          <img src="/img/lp/orangeDownArrow.png" alt="[Arrow]" />
        </div>
        <div class="flow-card">
          <div class="card-tip">STEP2</div>
          <div class="card-title">クレジットカードのご登録・決済</div>
          <div class="card-underline"></div>
          <div class="card-body text-pre-wrap">
            <span
              >提携プランをご利用いただける場合は、当ページ下部から、fondiにご登録いただいたEmailと、クレジットカード情報をご登録ください。</span
            ><span>自動的に決済が実行されます。</span>
          </div>
          <div class="mt-4 font-red font-bold">
            ＊提携プランをご利用いただくためには、fondiのアカウントが事前に必要です。
          </div>
        </div>
        <div class="arrow-wrapper">
          <img src="/img/lp/orangeDownArrow.png" alt="[Arrow]" />
        </div>
        <div class="flow-card">
          <div class="card-tip">STEP3</div>
          <div class="card-title">fondi上で、提携プランのご利用が可能に。</div>
          <div class="card-underline"></div>
          <div class="card-body text-pre-wrap">
            <span
              >当ページでのクレジットカードでの決済が完了すると、fondiのアプリ上にて、自動で提携プランがご利用可能になります。</span
            ><br /><span>fondiの全機能をお楽しみください。</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.flow-wrapper {
  position: relative;
  margin-top: -320px;
  padding: 80px 0 160px;
  overflow: hidden;
}
.bg-flow {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -50vw;
  width: 200vw;
  background-image: url('/img/lp/patterns/check.png');
  background-repeat: repeat;
  border-radius: 50%;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}
.bg-flow-wave {
  background-image: url('/img/lp/darkWave.png');
  height: 6vw;
  width: 100%;
  background-size: cover;
}
.flow-title {
  text-align: center;
}
.flow-title > .v-icon,
.flow-title > span {
  vertical-align: middle;
  font-size: 32px;
  color: #625d53;
  font-weight: bold;
}
.flow-title > span {
  padding: 0 8px;
}
.flow-card-wrapper {
  padding-top: 24px;
}
.flow-card {
  position: relative;
  background-color: #fff;
  box-shadow: 0px 1px 14px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: left;
  margin: 36px auto 0;
  padding: 60px 48px 46px;
  width: 1240px;
}
.card-tip {
  position: absolute;
  top: -50px;
  left: 32px;
  background-size: contain;
  width: 400px;
  height: 100px;
  color: #fff;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(/img/programs/fellowship/chie/lpFrmSubTitle.png);
}
.card-title {
  font-size: 46px;
  color: #5a5a5a;
  font-weight: bold;
  line-height: 1.2em;
}
.card-underline {
  background-image: url(/img/programs/fellowship/chie/lpPriceUnderLine.png);
  background-size: cover;
  background-position: center;
  border-radius: 4px;
  height: 8px;
}
.card-body {
  margin-top: 24px;
  color: #797979;
  font-weight: 600;
  font-size: 26px;
  line-height: 1.2em;
}
.arrow-wrapper {
  padding-top: 30px;
  text-align: center;
}
@media (min-width: 1024px) {
  .visible-md {
    display: none;
  }
}
@media (max-width: 1400px) {
  .flow-card {
    width: 1000px;
  }
  .card-title {
    font-size: 36px;
    line-height: 1.4em;
  }
  .card-body {
    margin-top: 28px;
    font-size: 21px;
    line-height: 1.3em;
  }
}
@media (max-width: 1023px) {
  .flow-card {
    width: 700px;
  }
}
@media (max-width: 767px) {
  .flow-wrapper {
    margin-top: -360px;
    padding: 32px 0 60px;
  }
  .flow-title > .v-icon,
  .flow-title > span {
    font-size: 22px;
  }
  .flow-card-wrapper {
    padding-top: 12px;
  }
  .flow-card {
    width: 340px;
    padding: 34px 16px;
    margin-top: 16px;
  }
  .card-tip {
    width: 164px;
    height: 35px;
    font-size: 15px;
    top: -18px;
    left: 16px;
  }
  .card-title {
    font-size: 20px;
  }
  .card-underline {
    height: 4px;
  }
  .card-body {
    font-size: 13px;
  }
  .arrow-wrapper {
    padding-top: 16px;
  }
  .arrow-wrapper > img {
    width: 64px;
  }
}
@media (max-width: 480px) {
  .bg-flow {
    width: 250vw;
    left: -75vw;
  }
  .flow-title > .v-icon,
  .flow-title > span {
    font-size: 14px;
  }
}
@media (max-width: 360px) {
  .flow-card {
    width: 300px;
    padding-bottom: 20px;
  }
  .card-title {
    font-size: 17px;
  }
  .card-body {
    font-size: 12px;
    margin-top: 16px;
  }
}
</style>
